import axios from 'axios';

export const getAllUsers = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`);
    return data;
};

export const getUserById = async (id) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${id}`);
    return data;
};

export const updateUser = async ( id, address, phone, addressDetails, notifyEmail ) => {
    const { data } = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/users/${id}`, {
        address,
        phone,
        ...(addressDetails && { addressDetails }),
        ...(notifyEmail && { notifyEmail })
    });
    return data;
};

export const deleteUser = async (id) => {
    const { data } = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/users/${id}`);
    return data;
};

export const addFavorite = async (id, productId) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/${id}/favorite/${productId}`);
    return data;
};

export const deleteFavorite = async (id, productId) => {
    const { data } = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/users/${id}/favorite/${productId}`);
    return data;
};
// Logged-in user's saved cart (identified by the login token)
export const getMyCart = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/me/cart`);
    return data;
};

export const saveMyCart = async (cart) => {
    const { data } = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/users/me/cart`, { cart });
    return data;
};
